import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

export interface BenchmarkRequestDto {
  regionCountry: string; // "MENA" default
  industry: string;      // "ALL" default
  year: number;          // current year default
  // productType: string;
}

export interface BenchmarkResponseDto<T> {
  id: number;
  regionCountryId: string;
  industryId: string;
  productType: string;
  factorValues: T[];
  year: number;
  dateCreated: string; // ISO string representation of DateTime

  previousData?: any;
}

export interface BenchmarkFactorValue {
  key: string;
  value: number;
  topPerformer: number;
}

export interface EngagementBenchmarkValues extends BenchmarkFactorValue {

}

export interface HappinessBenchmarkValues extends BenchmarkFactorValue {

}

export interface BenchmarkOptionsRequestDto {
  regionOrCountry: string;
  industry: string;
  year: number;
  productType: string
}

export interface BenchmarkOptionsResponseDto {
  availableOptions: BenchmarkOptionDto[];
}

export interface BenchmarkOptionDto {
  regionOrCountry: string;
  industry: string;
  matchLevel: string;

}

@Injectable({
  providedIn: 'root'
})
export class ExBenchmarkService {

  private benchmarkOptions$: BehaviorSubject<{ request: BenchmarkOptionsRequestDto, options: BenchmarkOptionsResponseDto }> =
    new BehaviorSubject<{ request: BenchmarkOptionsRequestDto, options: BenchmarkOptionsResponseDto }>(
      { request: null, options: {} as BenchmarkOptionsResponseDto }
    );

  private baseUrl = `${environment.coreApi}ex-benchmarks`;

  constructor(private http: HttpClient) { }

  getEngagementBenchmark(request: BenchmarkRequestDto): Observable<BenchmarkResponseDto<EngagementBenchmarkValues>[]> {
    return this.http.post<BenchmarkResponseDto<EngagementBenchmarkValues>[]>(`${this.baseUrl}/engagement-analysis`, request);
  }

  getHappinessBenchmark(request: BenchmarkRequestDto): Observable<BenchmarkResponseDto<HappinessBenchmarkValues>[]> {
    return this.http.post<BenchmarkResponseDto<HappinessBenchmarkValues>[]>(`${this.baseUrl}/happiness-analysis`, request);
  }

  getAiReadinessBenchmark(request: BenchmarkRequestDto): Observable<BenchmarkResponseDto<BenchmarkFactorValue>[]> {
    return this.http.post<BenchmarkResponseDto<BenchmarkFactorValue>[]>(`${this.baseUrl}/ai-readiness-analysis`, request);
  }

  getBenchmarkOptions(request: BenchmarkOptionsRequestDto): Observable<BenchmarkOptionsResponseDto> {
    if (!!this.benchmarkOptions$.value.options.availableOptions && this.benchmarkOptions$.value.request.productType === request.productType)
      return this.benchmarkOptions$.asObservable().pipe(
        map(data => data.options)
      );
    return this.http.post<BenchmarkOptionsResponseDto>(`${this.baseUrl}/options`, request).pipe(
      tap(options => {
        this.benchmarkOptions$.next({ request, options })
      })
    );
  }
}
